import { useMutation } from "@tanstack/react-query";

import { useCurrentCompanyId, useCurrentJobId } from "@/hooks";
import { httpClient } from "@/lib/http";
import {
  CandidacyComment,
  CreateOrUpdateCandidacyCommentRequest,
  HttpResponse,
} from "@/types";

export function useCreateCandidacyComment() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  const mutation = useMutation({
    mutationFn: async ({
      candidacyId,
      createCandidacyCommentRequest,
    }: {
      candidacyId: string;
      createCandidacyCommentRequest: CreateOrUpdateCandidacyCommentRequest;
    }) => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/candidacies/${candidacyId}/candidacy_comments`;
      const res = await httpClient.post<
        CandidacyComment,
        HttpResponse<CandidacyComment>,
        CreateOrUpdateCandidacyCommentRequest
      >(path, createCandidacyCommentRequest);

      return res.data;
    },
  });

  return mutation;
}
